import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, ArrowRight } from 'lucide-react';
import { usePage } from '../contexts/PageContext';
import SEO from '../components/SEO';
import RichText from '../components/RichText';

export default function ServicesPage() {
  const { t, seo } = usePage('services');
  const cards = [
    { n: '01', title: t('svc_1_title', 'Brand & Strategy AI'), desc: t('svc_1_desc', '') },
    { n: '02', title: t('svc_2_title', 'Attraction Engine'), desc: t('svc_2_desc', '') },
    { n: '03', title: t('svc_3_title', 'Identification & KYC'), desc: t('svc_3_desc', '') },
    { n: '04', title: t('svc_4_title', 'Risk & Legal Pre-evaluation'), desc: t('svc_4_desc', '') },
    { n: '05', title: t('svc_5_title', 'E-signature & Activation'), desc: t('svc_5_desc', '') },
    { n: '06', title: t('svc_6_title', 'Analytics & Optimization'), desc: t('svc_6_desc', '') },
  ];
  const steps = [
    { n: '01', t: t('step_1_title', 'Discovery & brand intake'), d: t('step_1_desc', '') },
    { n: '02', t: t('step_2_title', 'Configuration'), d: t('step_2_desc', '') },
    { n: '03', t: t('step_3_title', 'Storefront launch'), d: t('step_3_desc', '') },
    { n: '04', t: t('step_4_title', 'Continuous optimization'), d: t('step_4_desc', '') },
  ];
  return (
    <>
      <SEO title={seo.title} description={seo.description} keywords={seo.keywords} image={seo.og_image} />
      <section className="pt-24 pb-16 lg:pt-36 lg:pb-24">
        <div className="container-x">
          <span className="eyebrow">{t('hero_eyebrow', 'Our services')}</span>
          <h1 className="heading-display mt-8 text-[44px] sm:text-[64px] lg:text-[96px] max-w-5xl">{t('hero_title', 'One platform. Two strategies. Every digital banking product.')}</h1>
          <p className="mt-8 text-[16px] text-[#C6C4CF] max-w-2xl"><RichText text={t('hero_description', '')} /></p>
        </div>
      </section>
      <section className="py-16 border-t border-[#3A332A]">
        <div className="container-x grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-12 gap-y-16">
          {cards.map((c) => (
            <div key={c.n} className="group cursor-default">
              <p className="text-[#F5F137] text-sm tracking-[0.28em] font-medium">{c.n}</p>
              <h3 className="heading-display text-3xl lg:text-4xl mt-4 group-hover:text-[#F5F137] transition-colors">{c.title}</h3>
              <p className="mt-4 text-[#C6C4CF] leading-relaxed text-[15px]"><RichText text={c.desc} /></p>
              <span className="mt-6 inline-flex items-center gap-2 text-xs uppercase tracking-[0.28em] text-[#C6C4CF] group-hover:text-[#F5F137] transition-colors">Learn more <ArrowRight size={14} /></span>
            </div>
          ))}
        </div>
      </section>
      <section className="py-24 lg:py-32 border-t border-[#3A332A]">
        <div className="container-x">
          <span className="eyebrow">{t('process_title', 'How we onboard')}</span>
          <h2 className="heading-display text-[36px] lg:text-[64px] mt-6 max-w-3xl">{t('process_title', 'How we onboard your bank')}</h2>
          <div className="mt-16 border-t border-[#3A332A]">
            {steps.map((s, i) => (
              <div key={i} className="grid grid-cols-1 lg:grid-cols-12 gap-6 py-10 border-b border-[#3A332A] items-center">
                <div className="lg:col-span-2 text-[#F5F137] text-sm tracking-[0.28em]">{s.n}</div>
                <div className="lg:col-span-4"><h3 className="heading-display text-2xl lg:text-3xl">{s.t}</h3></div>
                <div className="lg:col-span-6 text-[#C6C4CF] leading-relaxed"><RichText text={s.d} /></div>
              </div>
            ))}
          </div>
          <div className="mt-12 flex flex-wrap gap-3">
            <Link to="/contact" className="btn-outline"><span>Talk to ClicksyHub</span><span className="arrow"><ArrowUpRight size={14} /></span></Link>
            <Link to="/pricing" className="btn-outline"><span>See pricing</span><span className="arrow"><ArrowUpRight size={14} /></span></Link>
          </div>
        </div>
      </section>
    </>
  );
}
